import type { SymbolPreviewItem } from '@/components/SymbolsPreview';
import type { SymbolKey } from '@/entities/symbol/types';
import type { AIMessage, Message } from '@/features/AIChat/context/utils';
import isHumanMessage from '@/features/AIChat/utils/isHumanMessage';

export const GX_REGEX = /GX\d{7}/g;

const extractCodesFromPart = (part: AIMessage['content'][number]): string[] => {
  if (part.kind === 'text') {
    return part.text.match(GX_REGEX) ?? [];
  }
  if (part.kind === 'tool_result') {
    return part.rows.map(row => row.code.trim()).filter((code): code is string => Boolean(code));
  }
  return [];
};

export function extractGxCodesFromMessage(msg: Message): string[] {
  if (isHumanMessage(msg)) return [];
  try {
    const raw = msg.content.flatMap(extractCodesFromPart);
    return [...new Set(raw)];
  } catch (e) {
    console.error('Error extracting GX codes from message:', e);
  }
  return [];
}

export function toCatalogueItem(data: any): SymbolPreviewItem {
  if (!data) {
    return {
      symbol: { Code: '', PeriodType: '', Period: '', TimeRef: '' } as SymbolKey,
      label: '',
      metadata: { Currency: '', Units: '', Title: '' }
    };
  }
  return {
    symbol: {
      Code: data.Code,
      PeriodType: data.PeriodType,
      Period: data.Period || '1',
      TimeRef: data.TimeRef
    } as SymbolKey,
    label: '',
    metadata: {
      Alias: data.Alias,
      Currency: data.Currency,
      Units: data.Units,
      Title: data.Title
    }
  };
}

export function gxQueryKey(code: string) {
  return ['gxCodeAIChat', code] as const;
}
